import { readLayerListEntryUuid } from './inventory-raw-readers';
import { readItemField } from './item-field-reader';

type Row = Record<string, unknown>;
const upper = (value: unknown): string => String(value ?? '').toUpperCase();
export const STATUS_ACTIVE_GRANT_BUCKETS: readonly string[] = ['ability', 'full_ability', 'quick_ability', 'free_ability', 'reaction_ability'];

/** Status grants precede other providers. Retire only status-owned entries and retain native first-wins ordering. */
export function statusGrantBucket(original: readonly unknown[], additions: readonly Row[], sources: ReadonlySet<string>): unknown[] {
    const others = original.filter(entry => !entry || typeof entry !== 'object'
        || !sources.has(upper(readItemField(entry as Row, 'source'))) && !sources.has(upper(readItemField(entry as Row, 'granted_by_status_id'))));
    const seen = new Set<string>();
    return [...additions, ...others].filter(entry => {
        const id = upper(readLayerListEntryUuid(entry));
        if (!id) return true;
        if (seen.has(id)) return false;
        seen.add(id); return true;
    });
}
